module.exports = __webpack_public_path__ + "assets/img/pulldown_0.8c05a98f.svg";